import React from "react";
import { Routes as RouterRoutes, Route } from "react-router-dom";
import ErrorBoundary from './components/ErrorBoundary';
import ScrollToTop from './components/ScrollToTop';
import Header from './components/ui/Header';
import ProtectedRoute from './components/ProtectedRoute';

// Import existing pages
import ConsumerDashboard from './pages/consumer-dashboard';
import ImpactTracking from './pages/impact-tracking';
import BusinessDashboard from './pages/business-dashboard';
import UniversityWallet from './pages/university-wallet';
import BusinessCertification from './pages/business-certification';
import SurpriseBagDetails from './pages/surprise-bag-details';
import NotFound from './pages/NotFound';

// Import new auth and scanner pages
import SignIn from './pages/auth/signin';
import SignUp from './pages/auth/signup';
import QRScannerScreen from './pages/qr-scanner-screen';

// Import new homepage and donation hub
import Homepage from './pages/homepage';
import DonationHub from './pages/donation-hub';

// Import new pages for missing functionality
import AvailableBags from './pages/available-bags';
import BusinessRegistration from './pages/business-registration';

function Routes() {
  return (
    <ErrorBoundary>
      <Header />
      <ScrollToTop />
      <RouterRoutes>
          {/* Homepage as default route */}
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          
          {/* Authentication Routes */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          
          {/* Public pages for homepage functionality */}
          <Route path="/available-bags" element={<AvailableBags />} />
          <Route path="/business-registration" element={<BusinessRegistration />} />
          
          {/* Public Donation Hub */}
          <Route path="/donation-hub" element={<DonationHub />} />
          
          {/* Protected Main Dashboard Routes - Require Authentication */}
          <Route path="/consumer-dashboard" element={
            <ProtectedRoute>
              <ConsumerDashboard />
            </ProtectedRoute>
          } />
          <Route path="/business-dashboard" element={
            <ProtectedRoute>
              <BusinessDashboard />
            </ProtectedRoute>
          } />
          <Route path="/university-wallet" element={
            <ProtectedRoute>
              <UniversityWallet />
            </ProtectedRoute>
          } />
          
          {/* Protected Feature Routes - Require Authentication */}
          <Route path="/impact-tracking" element={
            <ProtectedRoute>
              <ImpactTracking />
            </ProtectedRoute>
          } />
          <Route path="/business-certification" element={
            <ProtectedRoute>
              <BusinessCertification />
            </ProtectedRoute>
          } />
          <Route path="/surprise-bag-details" element={
            <ProtectedRoute>
              <SurpriseBagDetails />
            </ProtectedRoute>
          } />
          
          {/* QR Scanner Route - Protected */}
          <Route path="/qr-scanner-screen" element={
            <ProtectedRoute>
              <QRScannerScreen />
            </ProtectedRoute>
          } />
          
          {/* Fallback Route */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
  );
}

export default Routes;